//all user who login to trr org chart
export const setUserAccessType = accessType => {
    // console.log("REDUX ACTION")
    // console.log(accessType)
    return {
        type: 'SET_USER_ACCESS_TYPE',
        accessType: accessType,
    }
};

export const setNavigationAccess = nagivationAccess => {
    return {
        type: 'SET_USER_NAVIGATION_ACCESS',
        nagivationAccess: nagivationAccess,
    }
};